export default "__VITE_ASSET__DiTZ_tN5__"